import UserForm from '../components/UserForm';
import {graphql} from 'react-apollo';
import gql from 'graphql-tag';
import {User} from '../qql-shared/fragments';
import {SaveUserMutation, SaveUserMutationConfig} from '../qql-shared/mutations';

const UserQuery = gql`
  query user($_id:String!) {
    user(_id:$_id) {
      ...User
    }
  }
  ${User}
`;

const UserQueryConfig = {
  options: ({match}) => ({variables: {_id: match.params.id}})
};

export default graphql(SaveUserMutation, SaveUserMutationConfig)(graphql(UserQuery, UserQueryConfig)(UserForm));



// WEBPACK FOOTER //
// ./src/containers/UserEdit.js